<template lang="html">
  <div>
    <li class="col2">
      <slot></slot>
    </li>
    <p class="txtInfo">{{description}}</p>
  </div>
</template>

<script>
  export default {
    name: 'InputForm',

    props: {
      col: {
        type: Number,
        default: 1
      },
      description: {
        type: String,
        default: ''
      }
    },

    data() {
      return {}
    }
  }
</script>

<style lang="css" scoped>
  .v-application ul {
    padding-left: 0px;
  }
</style>

